<template>
    <div class="content-side">
        <ul class="nav-main">
            <li class="nav-main-item">
                <router-link class="nav-main-link" to="/">
                    <i class="nav-main-link-icon fa fa-rocket"></i>
                    <span class="nav-main-link-name">Portal</span>
                </router-link>
            </li>

            <li class="nav-main-heading">Personal</li>
            <li class="nav-main-item" @click="active('Facturas')">
                <router-link :class="activo === 'Facturas' ? 'active' : '' "
                             class="nav-main-link" to="/Facturas">
                    <i class="nav-main-link-icon fas fa-file-invoice-dollar"></i>
                    <span class="nav-main-link-name">Facturas</span>
                </router-link>
            </li>
            <li class="nav-main-item" @click="active('Clientes')">
                <router-link :class="activo === 'Clientes' ? 'active' : '' "
                             class="nav-main-link" to="/Clientes">
                    <i class="nav-main-link-icon fa fa-users"></i>
                    <span class="nav-main-link-name">Clientes</span>
                    <span class="nav-main-link-badge badge badge-pill"
                          :class="totales.clientes.total_results === 0 ? 'badge-danger' : 'badge-success'">
                        {{totales.clientes.total_results}}</span>
                </router-link>
            </li>
            <li class="nav-main-item"@click="active('Productos')">
                <router-link :class="activo === 'Productos' ? 'active' : '' "
                             class="nav-main-link" to="/Productos">
                    <i class="nav-main-link-icon fas fa-barcode"></i>
                    <span class="nav-main-link-name">Productos</span>
                    <span class="nav-main-link-badge badge badge-pill"
                    :class="totales.productos.total_results === 0 ? 'badge-danger' : 'badge-success'">
                        {{totales.productos.total_results}}
                    </span>
                </router-link>
            </li>
            <li class="nav-main-item" v-if="false">
                <a class="nav-main-link" href="">
                    <i class="nav-main-link-icon fa fa-lock"></i>
                    <span class="nav-main-link-name">Security</span>
                    <span class="nav-main-link-badge badge badge-pill badge-danger">1</span>
                </a>
            </li>
            <li class="nav-main-heading">Dashboards</li>
            <li class="nav-main-item" @click="active('Tableros')">
                <router-link :class="activo === 'Tableros' ? 'active' : '' "
                             class="nav-main-link" to="/Tableros">
                    <i class="nav-main-link-icon fas fa-chart-line"></i>
                    <span class="nav-main-link-name">Tablero</span>
                </router-link>
            </li>
        </ul>

        <input type="hidden" style="display: none" v-show="dummy"/>

    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';

    export default {
        name: "List",

        computed: {
            ...mapState([
                'totales'
            ]),
        },

        data() {
            return {
                dummy: {},
                activo: ''
            }
        },

        mounted: function () {
            this.getTotales().then( data => {
               this.SET_TOTALES(data);
            });

            setTimeout(() => {
                let rutas = this.$route.fullPath.split('/');
                if (rutas.length > 0)
                    this.activo = rutas[rutas.length - 1];
            },500)
        },

        methods: {
            ...mapActions([
                'getTotales'
            ]),

            ...mapMutations([
                'SET_TOTALES'
            ]),

            active: function (ruta) {
                this.activo = ruta;
            }

        }

    }
</script>

<style scoped lang="scss">

    @import "../../style/base";

    .content-side {
        margin: 0 auto;
        padding: 1.25rem 1.25rem 1px;
        overflow-x: hidden;
        font-size: 13px;

        .nav-main {
            padding-left: 0;
            list-style: none;

            & .nav-main-heading {
                color: #869099;
                padding-top: 1.75rem;
                padding-bottom: .25rem;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: .0625rem;
            }

            & .nav-main-item {
                @include flexColumn;

                & .nav-main-link {
                    position: relative;
                    @include flexRow;
                    align-items: center;
                    padding: .5rem .625rem;
                    margin: 1px 0;
                    min-height: 2.25rem;
                    font-weight: 600;
                    line-height: 1.25rem;
                    color: #495057;
                    border-radius: .2rem;
                    transition: color .12s ease-out;
                    text-decoration: none;
                    background-color: transparent;


                    &.active {
                        color: $white !important;
                        background-color: $sekaiBlue;
                        & .nav-main-link-name {
                            color: $white;
                        }
                        & .nav-main-link-icon {
                            color: $lightWhite;
                        }
                    }

                    &:HOVER {
                        color: $white;
                        background-color: $sekaiHover;

                        & .nav-main-link-name {
                            color: $white;
                        }

                        & .nav-main-link-icon {
                            color: $lightWhite;
                        }
                    }

                    & .nav-main-link-icon {
                        flex: 0 0 auto;
                        display: inline-block;
                        margin-right: .625rem;
                        min-width: 1rem;
                        text-align: center;
                        color: #0665d0;
                        font-size: 1rem;
                    }

                    & .nav-main-link-name {
                        flex: 1 1 auto;
                        @include flexRow;
                        max-width: 100%;
                        color: $black;
                    }

                    & .nav-main-link-badge {
                        flex: 0 0 auto;
                        @include flexRow;
                        @include absoluteCenter;
                        margin-left: .625rem;
                        padding-right: .375rem;
                        padding-left: .375rem;
                        font-size: .75rem;
                    }

                }

            }
        }
    }

</style>